
import React from 'react';
import './userAgreement.css';

const UserAgreement = () => {
  return (
    <div className="user-agreement-container">
      <h1>Пользовательское соглашение</h1>

      <h2>Стороны настоящего Соглашения</h2>
      <p>
        <strong>Клиент</strong> — физическое лицо, намеренное оформить и/или оформляющее Заявки на сайте, обладающее необходимым объемом дееспособности в соответствии с законодательством РФ.
      </p>
      <p>
        <strong>Продавец</strong> — ИП Кудишкин А. В., осуществляющий продажу табачной продукции исключительно дистанционным способом через сайт.
      </p>
      <p>
        Настоящее Соглашение составлено с учетом Федерального закона № 38-ФЗ “О рекламе” от 13.03.2006 и не является рекламой табачной продукции. Сайт Продавца создан для информирования Клиентов об ассортименте товаров и учета их мнений для оптимизации ассортимента или условий продаж.
      </p>

      <h2>Термины</h2>
      <p>
        <strong>Заявка</strong> — запрос Клиента, оформленный через сайт, содержащий пожелания о выборе, количестве и характеристиках товаров, которые Клиент желал бы приобрести у Продавца.
      </p>
      <p>
        <strong>Интернет-магазин</strong> — сайт Продавца, на котором осуществляется размещение информации о товарах, прием заявок и продажа товаров исключительно дистанционным способом.
      </p>

      <h2>Общие положения</h2>
      <ol>
        <li>
          Представленная на сайте продукция предназначена для ознакомления с ассортиментом и является предложением заключить договор купли-продажи дистанционным способом (публичной офертой).
        </li>
        <li>
          Все сделки купли-продажи товаров осуществляются только через сайт, без физического посещения магазина.
        </li>
        <li>
          Направляя Заявки через сайт, Клиент соглашается с условиями настоящего Соглашения.
        </li>
      </ol>
      <p>
        Продавец оставляет за собой право вносить изменения в настоящее Соглашение.
      </p>

      <h2>Оформление Заявки</h2>
      <ol>
        <li>
          Заявка оформляется Клиентом самостоятельно через сайт.
        </li>
        <li>
          Для оформления Заявки Клиент заполняет регистрационную форму и соглашается с условиями настоящей оферты.
        </li>
        <li>
          После оформления Заявки Клиент получает на указанный им электронный адрес подтверждение, включая информацию о стоимости товара, условиях оплаты и доставки.
        </li>
        <li>
          Продавец оставляет за собой право отказать Клиенту в регистрации или обработке Заявки без объяснения причин.
        </li>
      </ol>

      <h2>Приобретение Товара и переход права собственности</h2>
      <ol>
        <li>
          Информация о цене, наличии и характеристиках товаров, представленная на сайте, носит информационный характер.
        </li>
        <li>
          Переход права собственности на товар происходит после его оплаты и передачи товара Клиенту через службу доставки или иным согласованным способом.
        </li>
      </ol>

      <h2>Оплата Товара</h2>
      <ol>
        <li>
          Стоимость товаров указывается на сайте и может быть изменена Продавцом в одностороннем порядке.
        </li>
        <li>
          Оплата осуществляется онлайн банковской картой или другим способом, указанным на сайте.
        </li>
      </ol>

      <h2>Доставка</h2>
      <ol>
        <li>
          Доставка осуществляется по адресам, указанным Клиентом при оформлении Заявки, в сроки, оговоренные при подтверждении заказа.
        </li>
        <li>
          Стоимость и условия доставки указываются на сайте или сообщаются Клиенту при оформлении Заявки.
        </li>
      </ol>

      <h2>Возврат товара</h2>
      <ol>
        <li>
          Табачная продукция надлежащего качества не подлежит возврату в соответствии с законодательством РФ.
        </li>
        <li>
          В случае выявления недостатков товара возврат или замена осуществляется по согласованию с Продавцом.
        </li>
        <li>
          Для возврата средств Клиент обязан предоставить подтверждающие документы об оплате.
        </li>
      </ol>

      <h2>Уведомления и информационные сообщения</h2>
      <ol>
        <li>
          При оформлении Заявки и/или регистрации на сайте Клиент соглашается получать уведомления от Продавца, включая информацию о товарах, акциях и новостях.
        </li>
        <li>
          Уведомления направляются на электронную почту или номер телефона, указанные Клиентом при регистрации.
        </li>
      </ol>

      <h2>Дополнительные условия</h2>
      <ol>
        <li>
          Сайт может быть временно недоступен из-за технических или профилактических работ.
        </li>
        <li>
          Все споры между Клиентом и Продавцом решаются путем переговоров, а при недостижении соглашения передаются на рассмотрение в судебные органы РФ.
        </li>
      </ol>
    </div>
  );
};

export default UserAgreement;
